import classNames from "classnames";
import { useSearchParams } from "react-router-dom";
import { getStepsByType, setupWizard, UserType } from "../types";

const StepPills = ({ label, icon, isActive, isCompleted, step }: any) => {
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <li className="flex items-center justify-center text-uw-black text-sm after:content-['/'] after:mx-2 after:opacity-50 after:last:content-none text-nowrap">
      <button
        onClick={(ev) => {
          ev.preventDefault();
          if (isCompleted) {
            setSearchParams((prev) => {
              const newParams = new URLSearchParams(prev); // ✅ clone, don't mutate
              newParams.set("step", step);
              return newParams;
            });
          }
        }}
        className={classNames({
          "flex items-center gap-2  px-4 py-1": true,
          "text-uw-black font-bold rounded-md underline": isActive,
          "opacity-50": !isActive && !isCompleted,
          "font-bold": isCompleted,
          "cursor-default": !isCompleted,
        })}
      >
        {icon} {label}
      </button>
    </li>
  );
};

export const WizardProgress = ({
  step,
  userType,
}: {
  step: string;
  userType: UserType;
}) => {
  const currentIndex = setupWizard.findIndex((w) => w.key === step);
  return (
    <ol className="flex items-center w-full text-sm font-medium text-center text-gray-500 sm:text-base border-b py-4 overflow-auto">
      {getStepsByType(userType).map((w, index) => {
        return (
          <StepPills
            key={w.key}
            isActive={step === w.key}
            isCompleted={index < currentIndex}
            label={w.label}
            icon={w.icon}
            step={w.key}
          />
        );
      })}
    </ol>
  );
};
